












import Vue from "vue"
import scrumbs from "@/components/navigation/Scrumbs.vue"
import formlogin from "@/modules/login/form_login.vue"

export default Vue.extend({
  name: "login",

  components: {
    scrumbs,
    formlogin,
  },

});
